import { render } from "./CompanyContact.vue?vue&type=template&id=3ea6ed5c&scoped=true&ts=true"
import script from "./CompanyContact.vue?vue&type=script&lang=ts"
export * from "./CompanyContact.vue?vue&type=script&lang=ts"

import "./CompanyContact.vue?vue&type=style&index=0&id=3ea6ed5c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea6ed5c"]])

export default __exports__